import * as React from 'react';

// translation
import {translate} from "react-i18next";

import {Grid} from 'semantic-ui-react';

import {WorkflowOptionApprovalDto} from '../../services/Client';
import {ITranslatedComponent} from '../../redux/reducers/generalReducer';
import OptionApprovalProps from './OptionApprovalProps';

import ErrorBoundary from '../../utils/ErrorBoundary';
import ApprovalBlockHeader from './ApprovalBlockHeader';
import {AutoSizer, CellMeasurer, CellMeasurerCache, List, WindowScroller} from "react-virtualized";
import {MeasuredCellParent} from "react-virtualized/dist/es/CellMeasurer";

interface IOptionApprovalBlockProps extends ITranslatedComponent {
    approvals: WorkflowOptionApprovalDto[];
    style: {marginTop?: string};
    userLanguage: string;
    scrollToIndex:number;

    onApprovalApproved: (approval: WorkflowOptionApprovalDto, toggled: boolean) => void;
    onApprovalRejected: (approval: WorkflowOptionApprovalDto, toggled: boolean) => void;
    onApprovalRejectMessageEntered: (approval: WorkflowOptionApprovalDto, val: string) => void;
    onClickShowHistory: (approval: WorkflowOptionApprovalDto) => void;
    updatedScrollIndex:(index: number) => void;
}

class OptionApprovalBlock extends React.Component<IOptionApprovalBlockProps> {
    cache = new CellMeasurerCache({defaultHeight: 300, fixedWidth: true});
    listRef: List | null;

    componentDidUpdate(prevProps: Readonly<IOptionApprovalBlockProps>): void {
        this.cache.clearAll();

        if ((prevProps.approvals !== this.props.approvals) || (prevProps.userLanguage !== this.props.userLanguage)) {

            if (this.listRef) {
                this.listRef.forceUpdateGrid();
            }
        }
    }

    onAction = (
        action: (approval: WorkflowOptionApprovalDto, val?: string | boolean) => void,
        approval: WorkflowOptionApprovalDto,
        toggled?: boolean | null,
        val?: string,
    ) => {
        if (this.listRef) {
            this.listRef.forceUpdateGrid();
        }
        if (toggled === null) {
            action(approval, val);
        } else {
            action(approval, toggled);
        }
    }

    rowRender = ({index, key, parent, style}: {index: number, key: string, parent: MeasuredCellParent, style: object}) => (
        <CellMeasurer cache={this.cache} parent={parent} key={key} rowIndex={index} columnIndex={0}>
            {() => (
                <div style={style} className='approval-card-container'>
                    <ErrorBoundary >
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <ApprovalBlockHeader
                                        approval={this.props.approvals[index]}
                                    />
                                </Grid.Column>
                                <Grid.Column width={12}>
                                    <OptionApprovalProps
                                        approval={this.props.approvals[index]}
                                        userLanguage={this.props.userLanguage}
                                        onApprove={(approval, toggled) => {
                                            this.onAction(this.props.onApprovalApproved, approval, toggled);
                                            const finIndex = this.props.approvals.findIndex((app) => app.objectId === approval.objectId);
                                            this.props.updatedScrollIndex(finIndex);
                                        }}
                                        onReject={(approval, toggled) => {
                                            this.onAction(this.props.onApprovalRejected, approval, toggled);
                                            const finIndex = this.props.approvals.findIndex((app) => app.objectId === approval.objectId);
                                            this.props.updatedScrollIndex(finIndex);
                                        }}
                                        onRejectMessageEntered={(approval, val) => this.onAction(this.props.onApprovalRejectMessageEntered, approval, null, val)}
                                        onClickShowHistory={(approval: WorkflowOptionApprovalDto): void => this.props.onClickShowHistory(approval)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </ErrorBoundary>
                </div>
            )}
        </CellMeasurer>
    )

    render() {
        return (
            this.props.approvals.length === 0 ?
                (
                    <div style={{marginTop: "20px"}}>
                        {this.props.t("NO_PENDING_OPTIONS")}
                    </div>
                )
                :
                (
                    <WindowScroller>
                        {
                            ({height, scrollTop, isScrolling}) => (
                                <AutoSizer>
                                    {
                                        ({width}) => (
                                            <List
                                                ref={(ref) => this.listRef = ref}
                                                className='virtualized-list'
                                                style={this.props.style}
                                                height={height}
                                                width={width}
                                                scrollTop={scrollTop}
                                                scrollToIndex={this.props.scrollToIndex}
                                                isScrolling={isScrolling}
                                                rowCount={this.props.approvals.length}
                                                rowHeight={this.cache.rowHeight}
                                                rowRenderer={this.rowRender}
                                                overscanRowCount={10}
                                            />
                                        )}
                                </AutoSizer>
                            )}
                    </WindowScroller>
                )
        );
    }
}

export default translate(["APPROVAL_VIEW", "WORKFLOW"])(OptionApprovalBlock);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/OptionApprovalBlock.tsx